module.exports = __webpack_public_path__ + "static/media/crane-1.be57055b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/SwiftBankingResources/crane-1.svg
// module id = 25
// module chunks = 0